import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import moment from "moment";
import { FETCH_FORECAST_CATEGORY_SUBMISSIONS } from "./graphql";

const ChooseSubmissionView = ({
  forecastCategoryId,
  excludeSubmissionId,
  onSelect,
}) => {
  const { loading, error, data } = useQuery(
    FETCH_FORECAST_CATEGORY_SUBMISSIONS,
    {
      variables: { forecastCategoryId },
      fetchPolicy: "network-only",
    },
  );

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <div>
      <div>Choose a submission below to compare. </div>

      <div className="divide-y divide-gray-100 dark:divide-gray-700 mt-4">
        {data.submissions
          .filter((i) => `${i.id}` !== excludeSubmissionId)
          .map((i) => (
            <div key={i.id} className="mb-2 py-1">
              <Button onClick={() => onSelect(i)}>
                #{i.id}. {moment(i.submittedAt).format("YYYY-MM-DD HH:mm:ss")}{" "}
                by {i.user?.email}
              </Button>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ChooseSubmissionView;
